import { yupResolver } from '@hookform/resolvers/yup';
import { Button, Modal, Spin, type ModalProps } from 'antd';
import { FormProvider, useForm } from 'react-hook-form';

import { useRejectAdmissionApplicationMutation } from '@/api/endpoints/schools/schoolSelectionPanel';
import { DataSection, TextAreaField } from '@/shared/components';
import { useApiRequest } from '@/shared/hooks';

import { REJECT_APPLICATION_VALIDATION_SCHEMA } from './consts';
import styles from './RejectApplicationModal.module.scss';

interface IProp extends ModalProps {
  isModalOpen: boolean;
  handleCancel: VoidFunction;
  candidateName: string;
  schoolId: number;
  applicationId: number;
}

export const RejectApplicationModal = ({
  isModalOpen,
  handleCancel,
  candidateName,
  schoolId,
  applicationId,
}: IProp) => {
  const [rejectApplication, { isLoading: isApplicationDeclining }] = useRejectAdmissionApplicationMutation();

  const sendApiRequest = useApiRequest();

  const methods = useForm({
    defaultValues: {
      reason: '',
    },
    resolver: yupResolver(REJECT_APPLICATION_VALIDATION_SCHEMA),
  });

  const { handleSubmit } = methods;

  const handleRejectApplication = handleSubmit(({ reason }) =>
    sendApiRequest({
      successMessage: 'Заявка успешно отклонена',
      apiRequestCallback: () =>
        rejectApplication({
          schoolId,
          applicationId,
          rejectionReason: reason,
        }),
      successCallback: handleCancel,
    }),
  );

  return (
    <Modal
      width={600}
      open={isModalOpen}
      onCancel={handleCancel}
      footer={null}
      centered
    >
      <Spin spinning={isApplicationDeclining}>
        <FormProvider {...methods}>
          <div className={styles.wrapper}>
            <p className={styles.title}>Отклонить заявку</p>
            <p className={styles.description}>
              Укажите причину отклонения заявки участника:
              <br />
              {candidateName}
            </p>
            <DataSection
              titleText="Причина отклонения"
              wrapperClassName={styles['reject-reason-wrapper']}
              isTitleRequired
            >
              <TextAreaField
                className={styles['reject-reason']}
                autoSize={{ minRows: 5, maxRows: 10 }}
                fieldName="reason"
                placeholder="Введите причину отклонения"
                size="large"
              />
              <p>Эта причина будет отображена участнику</p>
            </DataSection>
            <div className={styles['buttons-wrapper']}>
              <Button
                size="large"
                onClick={handleCancel}
                className={styles.button}
              >
                Отмена
              </Button>
              <Button
                size="large"
                onClick={handleRejectApplication}
                danger
                className={styles.button}
                type="primary"
                disabled={isApplicationDeclining}
              >
                Отклонить заявку
              </Button>
            </div>
          </div>
        </FormProvider>
      </Spin>
    </Modal>
  );
};
